import { render, staticRenderFns } from "./MusicianForms.vue?vue&type=template&id=571ffc4b&scoped=true&"
import script from "./MusicianForms.vue?vue&type=script&lang=js&"
export * from "./MusicianForms.vue?vue&type=script&lang=js&"
import style0 from "./MusicianForms.vue?vue&type=style&index=0&id=571ffc4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571ffc4b",
  null
  
)

export default component.exports